module.exports = __webpack_public_path__ + "static/dire_wolf_attack_northfolk_family-80741ef468252489790ceedb9031ced3.jpg";